<template>
  <div class="home-page">
    <PrizePoolSection />
    <PersonalStatsSection :items="personalStats" />
    <NodeRewardWithdrawSection
      :account-address="accountAddress"
      :is-node="isNode"
      @success="refreshUserDashboard(accountAddress)"
    />
    <ReferralListSection
      :addresses="directReferrals"
      :empty-text="referralEmptyText"
    />
  </div>
</template>

<script>
import PrizePoolSection from "./home/components/PrizePoolSection.vue";
import PersonalStatsSection from "./home/components/PersonalStatsSection.vue";
import ReferralListSection from "./home/components/ReferralListSection.vue";
import NodeRewardWithdrawSection from "./user/components/NodeRewardWithdrawSection.vue";
import { fetchHomePersonalAndReferrals } from "./home/helpers/homeUserChain.js";
import { Notify } from "vant";
import { createPersonalStatsPlaceholder } from "./home/constants.js";

export default {
  components: {
    PrizePoolSection,
    PersonalStatsSection,
    ReferralListSection,
    NodeRewardWithdrawSection,
  },
  computed: {
    accountAddress() {
      return this.$store.state.user.accountAddress;
    },
    referralEmptyText() {
      return this.accountAddress
        ? "暂无直推用户"
        : "请先连接钱包后查看直推列表";
    },
  },
  data() {
    return {
      personalStats: createPersonalStatsPlaceholder(),
      directReferrals: [],
      isNode: false,
    };
  },
  mounted() {
    this.refreshUserDashboard(this.accountAddress);
  },
  watch: {
    accountAddress(val) {
      this.refreshUserDashboard(val);
    },
  },
  methods: {
    async refreshUserDashboard(addr) {
      if (!addr) {
        this.personalStats = createPersonalStatsPlaceholder();
        this.directReferrals = [];
        this.isNode = false;
        return;
      }
      try {
        const { personalStats, directReferrals, isNode } =
          await fetchHomePersonalAndReferrals(addr);
        this.personalStats = personalStats;
        this.directReferrals = directReferrals;
        this.isNode = isNode;
      } catch (err) {
        if (err?.code === "NO_CONTRACT_OR_WALLET") {
          this.personalStats = createPersonalStatsPlaceholder();
          this.directReferrals = [];
          this.isNode = false;
          return;
        }
        const msg =
          typeof err?.message === "string"
            ? err.message
            : "个人业绩数据读取失败";
        Notify({ type: "danger", message: msg });
        this.personalStats = createPersonalStatsPlaceholder();
        this.directReferrals = [];
        this.isNode = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100%;
  box-sizing: border-box;
  padding: 0 32px 32px;
  padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  color: #333;
}
</style>
